<nz-modal nzTitle="Report Generate History" [nzVisible]="visible" (nzOnCancel)="hide()" nzWidth="80%" [nzFooter]="null">
  <ng-container *nzModalContent>
    <st [req]="req" [columns]="columns" [data]="url" #st>
      <ng-template st-row="statusTpl" let-item>
        <ng-container *ngIf="item.status">
          <ng-container [ngSwitch]="item.status">
            <nz-tag *ngSwitchCase="0">N/A</nz-tag>
            <nz-tag *ngSwitchCase="1" nzColor="blue">
              <i nz-icon nzType="clock-circle"></i>
              Queued
            </nz-tag>
            <nz-tag *ngSwitchCase="2" nzColor="blue">
              <i nz-icon nzType="sync" [nzSpin]="true"></i>
              Processing
            </nz-tag>
            <nz-tag *ngSwitchCase="3" nzColor="success">
              <i nz-icon nzType="check-circle"></i>
              Completed
            </nz-tag>
            <nz-tag *ngSwitchCase="4" nzColor="error" nz-tooltip [nzTooltipTitle]="item.errorMessage">
              <i nz-icon nzType="close-circle"></i>
              Error
            </nz-tag>
          </ng-container>
        </ng-container>
      </ng-template>
    </st>
  </ng-container>
</nz-modal>
